// Copyright (c) 2016 Deere & Company

import AdditionalDetailsDataTestDomain, {getDefaultState as getAdditionalDetailsDataTestDomain} from '../state/additional-data-test-domain';
import actions from '../../actions-list';

const setRgaAdditionalDataTestDomain = (state, action) =>
    AdditionalDetailsDataTestDomain.update(state, {
        $set: action.rgaAdditionalDataTestParam
    });

export default (state = getAdditionalDetailsDataTestDomain(), action) => {

    const actionTypes = {
        [actions.UPDATE_RGA_ADDITIONAL_DATA_TEST_DOMAIN]: setRgaAdditionalDataTestDomain
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/reducers/additional-data-test-domain.js